import { getAutoGradeStatusFromContext } from '@/helpers/smartIntegrations';

export default {
  getterCourse                : newContent => newContent.course,
  getterContent               : newContent => newContent.content,
  getterSelectedContent       : newContent => newContent.selectedContent,
  getterSelectedIndexToRender : newContent => newContent.selectedIndexToRender,
  getterTemplateName          : newContent => newContent.course?.context.templateName || newContent.content?.context.templateName || 'timeline',
  getterEula                  : newContent => newContent.eula,
  getterAutoGradeStatus       : newContent => getAutoGradeStatusFromContext(newContent.course.context)
};
